"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaRDocumento = exports.yupRDocumento = void 0;
const yup = __importStar(require("yup"));
exports.yupRDocumento = yup.object({
    clientes: yup.array(yup.string().required()).required().default([]).label('Clientes'),
    area: yup.string().required().default('').label('Área do documento'),
    modelo: yup.string().required().default('').label('Modelo de versionamento do relatório'),
    nome: yup.string().required().default('').label('Nome do documento'),
    descricao: yup.string().notRequired().nullable().label('Descrição do documento'),
    anoGeracao: yup.number().notRequired().nullable().label('Ano letivo'),
    ativo: yup.boolean().required().default(true).label('Ativo'),
    contrato: yup.boolean().required().default(false).label('É um contrato de (re)matrícula'),
    requerimento: yup.boolean().required().default(false).label('É um requerimento de (re)matrícula'),
    coletaAceite: yup.boolean().required().default(false).label('Coleta aceite'),
    assinaOnline: yup.boolean().required().default(false).label('Será assinado digitalmente'),
    html: yup.string().required().default('').label('Conteúdo do documento'),
});
exports.schemaRDocumento = exports.yupRDocumento.shape({});
